module.exports = require("@formatjs/intl-relativetimeformat/polyfill");